export const initialMap = {
  mapId: 'seed_1',
  buildings: {
    '-3_-2': {
      built: true,
      destroying: false,
      evolving: false,
      level: 1,
      multiplier: 1,
      name: 'spaceship',
      blocked: false,
      production: 0,
      q: -3,
      r: -2,
      type: 'spaceship',
    },
    '-2_-2': {
      built: true,
      destroying: false,
      evolving: false,
      level: 1,
      multiplier: 1,
      name: 'mine',
      blocked: false,
      production: 0,
      q: -2,
      r: -2,
      type: 'mine',
    },
  },
  removedRocks: {},
  extraBuildings: {},
}

export const visitorMap = {
  mapId: 'seed_2',
  buildings: {
    '-3_-5': {
      blocked: false,
      built: false,
      destroying: false,
      evolving: false,
      level: 1,
      multiplier: 1,
      name: 'home',
      production: 0,
      q: -3,
      r: -5,
      repared: false,
      type: 'home',
    },
    '-4_-2': {
      blocked: false,
      built: false,
      destroying: false,
      evolving: false,
      level: 1,
      multiplier: 1,
      name: 'farm',
      production: 0,
      q: -4,
      r: -2,
      repared: false,
      type: 'food',
    },
    '1_-5': {
      blocked: false,
      built: false,
      destroying: false,
      evolving: false,
      level: 1,
      multiplier: 1,
      name: 'windmill',
      production: 0,
      q: 1,
      r: -5,
      repared: false,
      type: 'energy',
    },
    '4_-4': {
      built: true,
      destroying: false,
      evolving: false,
      level: 1,
      multiplier: 1,
      name: 'mine',
      production: 0,
      blocked: false,
      q: 4,
      r: -4,
      type: 'mine',
    },
    '3_-4': {
      built: true,
      destroying: false,
      evolving: false,
      level: 1,
      multiplier: 1,
      name: 'spaceship',
      blocked: false,
      production: 0,
      q: 3,
      r: -4,
      type: 'spaceship',
    },
  },
  removedRocks: {},
  extraBuildings: {},
}

export const visitorIndicators = {
  antimatter: 0,
  audioDisabled: false,
  cityLevel: 2,
  coins: 30,
  counters: {
    an_pen: 0,
    an_t: 0,
    an_tot: 0,
    an_xt: 3,
    qu_pen: 0,
    qu_t: 0,
    qu_tot: 0,
    qu_xt: 3,
    wc: 0,
  },
  energy: 1,
  energyOld: 0,
  food: 1,
  foodOld: 0,
  happiness: 0,
  happinessOld: 0,
  home: 1,
  homeOld: 0,
  oxygen: 0,
  oxygenOld: 0,
  phase: 3,
  playersAttacked: false,
  settlers: 0,
  settlersOld: 0,
  turn: 2,
  updatingData: false,
  water: 20,
  waterOld: 0,
}

export const misInfo = [
  {
    licenseId: '5c948a06fdc4bc00134da4f7',
    name: 'DEPONIA',
    type: 'LEADER',
  },
  {
    battleId: '5c94b5aceab1b10011811698',
    coins: 2,
    buildingName: 'farm',
    buildingLevel: 1,
    attacker: '5c94a4a8fdc4bc00134da502',
    defender: '5c9489ed45e8b90011195274',
    durationAttacker: 92082,
    rightAnswersAttacker: 0,
    durationDefender: 5514,
    rightAnswersDefender: 1,
    winnerId: '5c9489ed45e8b90011195274',
    loserId: '5c94a4a8fdc4bc00134da502',
    type: 'BATTLE_WON',
  },
  {
    battleId: '5c94b5aceab1b10011811698',
    coins: 2,
    buildingName: 'farm',
    buildingLevel: 1,
    attacker: '5c94a4a8fdc4bc00134da502',
    defender: '5c9489ed45e8b90011195274',
    durationAttacker: 92082,
    rightAnswersAttacker: 0,
    durationDefender: 5514,
    rightAnswersDefender: 1,
    winnerId: '5c9489ed45e8b90011195274',
    loserId: '5c94a4a8fdc4bc00134da502',
    type: 'BATTLE_LOST',
  },
]

export const visitorMaps = {
  '5c9357ab45e8b90011195247': {
    mapId: 'seed_1',
    buildings: {
      '-4_-2': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'water_treatment_plant',
        blocked: false,
        production: 0,
        q: -4,
        r: -2,
        type: 'water',
      },
      '-5_-2': {
        built: true,
        destroying: false,
        evolving: false,
        level: 2,
        multiplier: 1,
        name: 'windmill',
        blocked: false,
        production: 0,
        q: -5,
        r: -2,
        type: 'energy',
      },
      '-3_-2': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'spaceship',
        blocked: false,
        production: 0,
        q: -3,
        r: -2,
        type: 'spaceship',
      },
      '-2_-2': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'mine',
        blocked: false,
        production: 0,
        q: -2,
        r: -2,
        type: 'mine',
      },
    },
    removedRocks: {},
    extraBuildings: {},
  },
  '123456789012345678901232': {
    mapId: 'seed_3',
    buildings: {
      '1_-2': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'mine',
        production: 0,
        blocked: false,
        q: 1,
        r: -2,
        type: 'mine',
      },
      '0_-2': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'spaceship',
        blocked: false,
        production: 0,
        q: 0,
        r: -2,
        type: 'spaceship',
      },
    },
    removedRocks: {},
    extraBuildings: {},
  },
  '123456789012345678901233': {
    mapId: 'seed_4',
    buildings: {
      '2_-3': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'mine',
        production: 0,
        blocked: false,
        q: 2,
        r: -3,
        type: 'mine',
      },
      '1_-3': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'spaceship',
        blocked: false,
        production: 0,
        q: 1,
        r: -3,
        type: 'spaceship',
      },
    },
    removedRocks: {},
    extraBuildings: {},
  },
  '123456789012345678901234': {
    mapId: 'seed_5',
    buildings: {
      '-1_-4': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'mine',
        production: 0,
        blocked: false,
        q: -1,
        r: -4,
        type: 'mine',
      },
      '-2_-4': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'spaceship',
        blocked: false,
        production: 0,
        q: -2,
        r: -4,
        type: 'spaceship',
      },
    },
    removedRocks: {},
    extraBuildings: {},
  },
  '123456789012345678901235': {
    mapId: 'seed_6',
    buildings: {
      '0_0': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'mine',
        production: 0,
        blocked: false,
        q: 0,
        r: 0,
        type: 'mine',
      },
      '-1_0': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'spaceship',
        blocked: false,
        production: 0,
        q: -1,
        r: 0,
        type: 'spaceship',
      },
    },
    removedRocks: {},
    extraBuildings: {},
  },
  '123456789012345678901236': {
    mapId: 'seed_7',
    buildings: {
      '0_0': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'mine',
        production: 0,
        blocked: false,
        q: 0,
        r: 0,
        type: 'mine',
      },
      '-1_0': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'spaceship',
        blocked: false,
        production: 0,
        q: -1,
        r: 0,
        type: 'spaceship',
      },
    },
    removedRocks: {},
    extraBuildings: {},
  },
  '123456789012345678901237': {
    mapId: 'seed_8',
    buildings: {
      '-2_-2': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'mine',
        production: 0,
        blocked: false,
        q: -2,
        r: -2,
        type: 'mine',
      },
      '-3_-2': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'spaceship',
        blocked: false,
        production: 0,
        q: -3,
        r: -2,
        type: 'spaceship',
      },
    },
    removedRocks: {},
    extraBuildings: {},
  },
  '123456789012345678901238': {
    mapId: 'seed_9',
    buildings: {
      '-2_-2': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'mine',
        production: 0,
        blocked: false,
        q: -2,
        r: -2,
        type: 'mine',
      },
      '-3_-2': {
        built: true,
        destroying: false,
        evolving: false,
        level: 1,
        multiplier: 1,
        name: 'spaceship',
        blocked: false,
        production: 0,
        q: -3,
        r: -2,
        type: 'spaceship',
      },
    },
    removedRocks: {},
    extraBuildings: {},
  },
}

export const playerList = {
  '123456789012345678901238': {
    licenseId: '123456789012345678901238',
    cityLevel: 10,
    colonyName: 'COOPER STATION',
    colonyShield: {
      bannerColor: 'green',
      bannerGeometry: 1,
      emblemColor: 'lightgreen',
      emblemGeometry: 5,
    },
    batp: 1,
    batd: 0,
    connected: true,
    created: 1553159184186,
    name: 'Aspirante #2360',
    settlers: 2180,
    attackableBuildings: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
    },
  },
  '5c9357ab45e8b90011195247': {
    licenseId: '5c9357ab45e8b90011195247',
    cityLevel: 9,
    colonyName: 'ESTRELLA DE LA MUERTE',
    colonyShield: {
      bannerColor: 'black',
      bannerGeometry: 2,
      emblemColor: 'red',
      emblemGeometry: 10,
    },

    batp: 0,
    batd: 0,
    connected: true,
    created: 1553160135886,
    name: 'Aspirante #3076',
    settlers: 850,
    attackableBuildings: {
      1: 1,
      2: 0,
      3: 0,
      4: 0,
    },
  },
  '123456789012345678901232': {
    licenseId: '123456789012345678901232',
    cityLevel: 8,
    colonyName: 'THE MARTIAN COLONY',
    colonyShield: {
      bannerColor: 'blue',
      bannerGeometry: 3,
      emblemColor: 'red',
      emblemGeometry: 9,
    },
    batp: 0,
    batd: 0,
    connected: true,
    created: 1553160135886,
    name: 'Aspirante #6935',
    settlers: 184,
    attackableBuildings: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
    },
  },
  '123456789012345678901233': {
    licenseId: '123456789012345678901233',
    cityLevel: 6,
    colonyName: 'THIS IS MARSTOWN',
    colonyShield: {
      bannerColor: 'green',
      bannerGeometry: 4,
      emblemColor: 'red',
      emblemGeometry: 8,
    },
    batp: 0,
    batd: 0,
    connected: true,
    created: 1553160135886,
    name: 'Aspirante #1964',
    settlers: 145,
  },
  '123456789012345678901234': {
    licenseId: '123456789012345678901234',
    cityLevel: 5,
    colonyName: 'NEW HAMPSHIRETOWN',
    colonyShield: {
      bannerColor: 'green',
      bannerGeometry: 4,
      emblemColor: 'red',
      emblemGeometry: 10,
    },
    batp: 0,
    batd: 0,
    connected: true,
    created: 1553160135886,
    name: 'Aspirante #7870',
    settlers: 43,
    attackableBuildings: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
    },
  },
  '123456789012345678901235': {
    licenseId: '123456789012345678901235',
    cityLevel: 5,
    colonyName: 'DINOVILLE DOMAINS',
    colonyShield: {
      bannerColor: 'green',
      bannerGeometry: 4,
      emblemColor: 'red',
      emblemGeometry: 7,
    },
    batp: 0,
    batd: 0,
    connected: true,
    created: 1553160135886,
    name: 'Aspirante #4076',
    settlers: 35,
  },
  '123456789012345678901236': {
    licenseId: '123456789012345678901236',
    cityLevel: 4,
    colonyName: '30 SECONDS TO MARS',
    colonyShield: {
      bannerColor: 'green',
      bannerGeometry: 4,
      emblemColor: 'red',
      emblemGeometry: 6,
    },
    batp: 0,
    batd: 0,
    connected: true,
    created: 1553160135886,
    name: 'Aspirante #2165',
    settlers: 1,
    attackableBuildings: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
    },
  },
  '123456789012345678901237': {
    licenseId: '123456789012345678901237',
    cityLevel: 3,
    colonyName: 'TOLEDO MARCIANO',
    colonyShield: {
      bannerColor: 'green',
      bannerGeometry: 4,
      emblemColor: 'red',
      emblemGeometry: 5,
    },
    batp: 0,
    batd: 0,
    connected: true,
    created: 1553160135886,
    name: 'Aspirante #9385',
    settlers: 0,
    attackableBuildings: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
    },
  },
}

export const initialUI = {
  tutorialMessage: {
    show: false,
    message: 'tutorial.common_texts.enter',
  },
  map: {
    zoom: false,
    ranking: false,
    documents: false,
    indicators: false,
    settings: true,
    globeAlert: false,
    sessionCounter: false,
    helpButton: false,
    userShield: false,
    feed: false,
    nextTurnButton: false,
  },
  mining: {
    answer: true,
    create: false,
    dispute: false,
    displayInfo: true,
    wildCardButton: false,
    refuseButton: false,

    indicators: false,
    documentsButton: false,
    userShield: false,
    sessionCounter: false,
    settingsButton: true,
    helpButton: false,
    mapButton: true,

    nextTurnButton: true,
  },
  phase1Hide: {
    ranking: true,
    antimatter: true,
    tab_summary: false,
    tab_quarry: true,
    tab_mis: true,
    tab_battles: true,
    helpBtn: true,
    settingsBtn: true,
    sessionCounter: true,
  },
  building: {
    buildingsAvailable: [
      'home',
      'windmill',
      'solar_panel',
      'oxygen_globe',
      'water_treatment_plant',
      'farm',
      'park',
      'spa',
      'gym',
      'social_club',
      'disco',
      'audience',
    ],
  },
}

export const initialUrlUI = {
  tutorialMessage: {
    show: false,
    message: 'tutorial.common_texts.enter',
  },
  map: {
    zoom: false,
    ranking: false,
    documents: false,
    indicators: false,
    settings: false,
    globeAlert: false,
    sessionCounter: false,
    helpButton: false,
    userShield: false,
    feed: false,
    nextTurnButton: false,
  },
  mining: {
    answer: true,
    create: false,
    dispute: false,
    displayInfo: true,
    wildCardButton: false,
    refuseButton: false,

    indicators: false,
    documentsButton: false,
    userShield: false,
    sessionCounter: false,
    settingsButton: false,
    helpButton: false,
    mapButton: true,

    nextTurnButton: true,
  },
  phase1Hide: {
    ranking: true,
    antimatter: true,
    tab_summary: false,
    tab_quarry: true,
    tab_mis: true,
    tab_battles: true,
    helpBtn: true,
    settingsBtn: false,
    sessionCounter: true,
  },
  building: {
    buildingsAvailable: [
      'home',
      'windmill',
      'solar_panel',
      'oxygen_globe',
      'water_treatment_plant',
      'farm',
      'park',
      'spa',
      'gym',
      'social_club',
      'disco',
      'audience',
    ],
  },
}

export const indicators = [
  {
    id: 'antimatter',
    table: 'blue',
    icon: 'icon-antimateria',
    value: 0,
  },
  {
    id: 'coins',
    table: 'violet',
    icon: 'icon-gcoins',
    value: 0,
  },
  {
    id: 'happiness',
    table: 'darkgreen',
    icon: 'icon-happiness',
    value: 0,
  },
  {
    id: 'food',
    table: 'normal',
    icon: 'icon-feed',
    value: 0,
  },
  {
    id: 'oxygen',
    table: 'normal',
    icon: 'icon-o2',
    value: 0,
  },
  {
    id: 'home',
    table: 'normal',
    icon: 'icon-houses',
    value: 0,
  },
  {
    id: 'energy',
    table: 'normal',
    icon: 'icon-energy',
    value: 0,
  },
  {
    id: 'water',
    table: 'normal',
    icon: 'icon-water',
    value: 0,
  },
]

export const initialGroupData = {
  session: 1,
  blocked: false,
  maxBattlesToAttack: 2,
  maxBattlesToDefend: 2,
  maxTurns: 2,
  sessions: 24,
  topic: 'Mars Academy',
  endGame: false,
}

export const initialUserData = {
  updatingData: false,
  counters: {
    an_pen: 0,
    an_t: 7,
    an_tot: 7,
    an_xt: 7,
    qu_pen: 0,
    qu_t: 0,
    qu_tot: 0,
    qu_xt: 0,
    wc: 0,
  },
  session: 1,
  turn: 1,
  phase: 1,
  antimatter: 0,
  cityLevel: 1,
  coins: 0,
  energy: 0,
  energyOld: 0,
  food: 0,
  foodOld: 0,
  happiness: 0,
  happinessOld: 0,
  home: 0,
  homeOld: 0,
  oxygen: 0,
  oxygenOld: 0,
  settlers: 0,
  settlersOld: 0,
  water: 0,
  waterOld: 0,
  playersAttacked: false,
}

export const initialCurrentUser = {
  cityLevel: 1,
  colonyName: 'MARSCADEMY',
  colonyShield: {
    bannerColor: 'lightgrey',
    bannerGeometry: 2,
    emblemColor: 'yellow',
    emblemGeometry: 4,
  },
  id: '5c934d95fdc4bc00134da4e5',
  licenseId: '5c934d95fdc4bc00134da4e5',
  connected: true,
  name: '#5858',
  playersAttacking: false,
  settlers: 0,
  position: 9,
  batd: 0,
  playersAttacked: false,
}

export const battleOne = {
  id: 'test',
  players: ['5c9357ab45e8b90011195247', '5c934d95fdc4bc00134da4e5'],
  info: {
    hits: 0,
    fails: 0,
    question: 1,
  },
  questions: [
    '5c3eefbcfaff8ad688b1c1e9',
    '5c3eefbcfaff8ad688b1c1ee',
    '5c3eefbcfaff8ad688b1c1f3',
    '5c3eefbcfaff8ad688b1c1f8',
    '5c3eefbdfaff8ad688b1c1fb',
  ],
  resolvedForAttacker: false,
  resolvedForDefender: false,
  deleted: false,
  createdBy: '5c9357ab45e8b90011195247',
  groupId: '5c9c65a8b8431b00113caa58',
  building: {
    q: -2,
    r: -3,
    level: 1,
    name: 'home',
    type: 'home',
    prize: 2,
  },
  rivalId: '5c9357ab45e8b90011195247',
  session: 1,
  results: {
    '5c934d95fdc4bc00134da4e5': {
      finished: true,
      startTime: 1553766247383.0,
      endTime: 1553766279884.0,
      '5c3eefbcfaff8ad688b1c1e9': {
        selectedKey: 3,
        right: false,
        correctChoice: 1,
      },
      '5c3eefbcfaff8ad688b1c1ee': {
        selectedKey: 1,
        right: false,
        correctChoice: 3,
      },
      '5c3eefbcfaff8ad688b1c1f3': {
        selectedKey: 3,
        right: false,
        correctChoice: 1,
      },
      '5c3eefbcfaff8ad688b1c1f8': {
        selectedKey: 3,
        right: false,
        correctChoice: 2,
      },
      '5c3eefbdfaff8ad688b1c1fb': {
        selectedKey: 3,
        right: false,
        correctChoice: 1,
      },
    },
  },
}

export const initialProfileBattles = [battleOne]
